import React from 'react' // 'useEffect' e 'useState' não são mais necessários para este cenário
// import { useSelector } from 'react-redux' // Remover se o Redux 'menu' não for usado em mais lugar algum neste componente

import {
  CDropdown,
  CDropdownItem,
  CDropdownMenu,
  CDropdownToggle
} from '@coreui/react'
import CIcon from '@coreui/icons-react' // Importação do CIcon é essencial para usar os ícones do CoreUI

const TheHeaderDropdown = () => {
  // As linhas de Redux e estado 'config' foram removidas/comentadas,
  // pois não são mais necessárias para um menu estático de "Trocar Senha" e "Logout".
  // const menu = useSelector(state => state.menu)
  // const [config, setConfig] = useState([]);

  // O useEffect anterior também foi removido, pois não há lógica dinâmica de carregamento de menu.
  // useEffect(() => {
  //   const n = menu.find(e => e.id_empresa === 1);
  //   if (n) {
  //     setConfig(n.paginas);
  //   }
  // }, [menu]);

  return (
    <CDropdown
      inNav
      className="c-header-nav-items mx-2"
      direction="down"
    >
      <CDropdownToggle className="c-header-nav-link" caret={false}>
      <i class="fa fa-bars" /> {/* Ícone para o toggle do dropdown */}
      </CDropdownToggle>
      <CDropdownMenu className="pt-0" placement="bottom-end" style={{ maxHeight: '500px', overflowY: 'auto' }}>

        {/* Item "Trocar Senha" */}
        {/* O 'to' deve ser a rota (URL) configurada no seu React Router, por exemplo, '/trocarsenha' */}
        <CDropdownItem to="/trocarsenha">
          🔐 {/* Ícone do CoreUI para "cadeado" */}
          Trocar Senha
        </CDropdownItem>

        <CDropdownItem divider /> {/* Linha divisória */}

        {/* Item "Logout" */}
        <CDropdownItem to="/Login"> {/* Assumindo que '/Login' é sua rota de logout/página de login */}
          <i className="fa fa-sign-out mfe-2" /> {/* Ícone Font Awesome para "sair" */}
          Logout
        </CDropdownItem>
      </CDropdownMenu>
    </CDropdown>
  )
}

export default TheHeaderDropdown